module.exports = __webpack_public_path__ + "static/media/ic_back.eb743d15.svg";